type Props = {
  roleId?: string;
  PIN?: string;
};

const defaultData: Props = {
  roleId: "",
  PIN: "",
};

export class CreateWalletErrorModel {
  roleId?: string;
  PIN?: string;

  constructor(data: Props = defaultData) {
    this.roleId = data.roleId || "";
    this.PIN = data.PIN || "";
  }
}
